import React from 'react'

export default function ContactScreen() {
  return (
    <div>ContactScreen</div>
  )
}
